import { Droplets, Phone, Mail, MapPin } from "lucide-react";
import { Logo } from "@/components/Navbar";

export default function Footer() {
  return (
    <footer className="navy-bg text-slate-300">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 grid gap-10 md:grid-cols-4">
        <div className="space-y-4">
          <Logo dark />
          <p className="text-sm text-slate-400 max-w-xs">
            Auckland's trusted water delivery. Fast, reliable delivery of up to 11,000L, right when you need it.
          </p>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4">Services</h4>
          <ul className="space-y-2 text-sm text-slate-400">
            <li>Pool Filling</li>
            <li>Tank Refills</li>
            <li>Construction Sites</li>
            <li>Emergency Supply</li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4">Company</h4>
          <ul className="space-y-2 text-sm text-slate-400">
            <li>About Us</li>
            <li>Coverage Area</li>
            <li>Pricing</li>
            <li>Contact</li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4">Get in touch</h4>
          <ul className="space-y-3 text-sm text-slate-400">
            <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-blue-400" /> 022 633 3426</li>
            <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-blue-400" /> info@needh2o.co.nz</li>
            <li className="flex items-center gap-2"><MapPin className="w-4 h-4 text-blue-400" /> Greater Auckland</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-slate-500 flex items-center justify-center gap-2">
        <Droplets className="w-3.5 h-3.5 text-blue-400" />
        © {new Date().getFullYear()} Blake's Quality Water. All rights reserved.
      </div>
    </footer>
  );
}
